import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ConfigService } from './auth/config.service';
import { catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class SocietyService {

  constructor(private http: HttpClient, private configService: ConfigService, private router: Router) { }

  registration(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/AddSocietyUser`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Something went failed.'));
      })
    );
  }
  getSocietyInfo(action: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=${action}&Id=0`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Society Info retrieval failed.'));
      })
    );
  }
  getDropDownData() {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetDropdownData`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Data retrieval failed.'));
      })
    );
  }

  getDistrict(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=DistrictData&Id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('District retrieval failed.'));
      })
    );
  }

  getMemberDoc(Id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetMemberDoc?Id=${Id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => response),
      catchError((err) => {
        console.error('Error fetching member document:', err);
        return throwError(() => new Error('Member document retrieval failed.'));
      })
    );
  }

  addMemberDoc(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/AddMemberDoc`;
    return this.http.post<any>(apiUrl, data).pipe(
      map(response => response),
      catchError(err => {
        console.error('Error uploading member document:', err);
        return throwError(() => new Error('Member document upload failed.'));
      })
    );
  }


  addCertificate(formData: FormData) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/UploadCertificate`;
    return this.http.post<any>(apiUrl, formData).pipe(
      map((response) => response),
      catchError((err) => {
        console.error('Error uploading UploadCertificate', err);
        return throwError(() => new Error('UploadCertificate upload failed.'));
      })
    );
  }




  getCircle(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=SocietyCircleData&Id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Circle retrieval failed.'));
      })
    );
  }

  getBankDetails(bankType: string) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetBankList?bankType=${bankType}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Circle retrieval failed.'));
      })
    );
  }
  GetBranchList(bankType: string, bankName: string) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetBranchList?bankType=${bankType}&bankName=${bankName}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Circle retrieval failed.'));
      })
    );
  }
  GetBranchDetails(bankType: string, bankName: string, branchName: string) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetBranchDetails?bankType=${bankType}&bankName=${bankName}&branchName=${branchName}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Circle retrieval failed.'));
      })
    );
  }




  AddSocietyMemberShare(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/AddSocietyMemberShare`;
    return this.http.post<any>(apiUrl, data).pipe(
      map(response => response),
      catchError(err => {
        console.error('Error uploading member document:', err);
        return throwError(() => new Error('Member document upload failed.'));
      })
    );
  }
  GetSocietyMemberShare() {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetSocietyMemberShare`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Circle retrieval failed.'));
      })
    );
  }
  //This changes by abhishek --start(3/11/2025)
  getsubcircle(id: any) {

    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=SubCircleData&Id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Block retrieval failed.'));
      })
    );
  }

  //This changes by abhishek --end

  getBlock(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=BlockData&Id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Block retrieval failed.'));
      })
    );
  }
  getPanchayat(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=PanchayatData&Id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Panchayat retrieval failed.'));
      })
    );
  }
  getVillage(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=VillageData&PanchayatId=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      // catchError((err) => {
      //   return throwError(() => new Error('Village retrieval failed.'));
      // })
    );
  }
  getLocalBody(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=LocalBodyData&Id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      // catchError((err) => {
      //   return throwError(() => new Error('Village retrieval failed.'));
      // })
    );
  }
  getWards(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=WardData&Id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      // catchError((err) => {
      //   return throwError(() => new Error('Village retrieval failed.'));
      // })
    );
  }
  getWatertypeList(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=WaterType&Id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      // catchError((err) => {
      //   return throwError(() => new Error('Village retrieval failed.'));
      // })
    );
  }
  addUserSociety(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/Add_New_Society?UserId=0&iSocietyId=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      // catchError((err) => {
      //   return throwError(() => new Error('Village retrieval failed.'));
      // })
    );
  }
  getUserSociety() {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetSocietyDetails?UserId=0`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      // catchError((err) => {
      //   return throwError(() => new Error('Village retrieval failed.'));
      // })
    );
  }
  saveSocietyDetails(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/UpdateSocietyDetails`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Something went wrong to update Society.'));
      })
    );
  }
  addSocietyMember(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/AddSocietyMember`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Request not submitted.'));
      })
    );
  }
  getMemberType(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=MemberType&Id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Member Type retrieval failed.'));
      })
    );
  }
  getMemberCastCategory() {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=SocietyType&Id=5`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Cast Category retrieval failed.'));
      })
    );
  }
  getMemberOccuption() {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=SocietyType&Id=8`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Member Occuption retrieval failed.'));
      })
    );
  }
  getMembershipType() {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=SocietyType&Id=6`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Membership Type retrieval failed.'));
      })
    );
  }
  getMemberDesignation() {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=SocietyType&Id=7`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Member Designation retrieval failed.'));
      })
    );
  }
  getSocietyMemberList() {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetMemberlist`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Member List retrieval failed.'));
      })
    );
  }
  addSocietyLaws(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/AddSocietyByLaw`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Request not submitted.'));
      })
    );
  }
  getSocietyLawList() {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetAllSocietyLaw`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Society Laws retrieval failed.'));
      })
    );
  }
  deleteSocietyLaws(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/DeleteSocietylaw?Id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Society Laws retrieval failed.'));
      })
    );
  }
  addElectionDetails(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/AddSocietyElection`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Request not submitted.'));
      })
    );
  }
  getElectionDetails() {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetAllSocietyElection`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Election Details retrieval failed.'));
      })
    );
  }
  deleteMember(id: any) {

    const apiUrl = `${this.configService.getApiUrl()}/Society/DeleteSocietyMember?Id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Delete Society Member failed.'));
      })
    );
  }


  deleteElectionDetails(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/DeleteSocietyElection?Id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Delete Society Election failed.'));
      })
    );
  }
  addSocietyProceeding(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/AddSocietyProceeding`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Society Proceeding Request not submitted.'));
      })
    );
  }
  getSocietyProceedingList() {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetAllSocietyProceeding`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Society Proceeding retrieval failed.'));
      })
    );
  }
  deleteSocietyProceeding(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/DeleteSocietyProceeding?Id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Society Proceeding retrieval failed.'));
      })
    );
  }
  addOtherDocument(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/AddSocietyDocument`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Other Document Request not submitted.'));
      })
    );
  }
  getOtherDocumentList() {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetAllSocietyDocument`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Other Document retrieval failed.'));
      })
    );
  }
  deleteOtherDocument(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/DeleteSocietyDocument?Id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Other Document deleted failed.'));
      })
    );
  }

  addBankDetails(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/SaveBankDetails`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Bank Details Request not submitted.'));
      })
    );
  }
  getBankDetailsList() {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetBankDetails`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Other Document retrieval failed.'));
      })
    );
  }
  deleteBankDetails(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/DeleteBankDetails?Id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Bank Details deleted failed.'));
      })
    );
  }

  addRegistrationFee(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/AddSocietyFee`;

    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Registration Fee Request not submitted.'));
      })
    );
  }
  getRegFeeList() {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetAllSocietyFee`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Registration Fee retrieval failed.'));
      })
    );
  }
  deleteRegFee(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/DeleteSocietyFee?Id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Registration Fee deleted failed.'));
      })
    );
  }
  getSocietyTabsData(tab: any, societyId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetAll?action=${tab}&&iScoietyDetailId=${societyId}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error(tab + ' retrieval failed.'));
      })
    );
  }
  submitApplication(action: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/SubmitApplication?action=${action}`;

    return this.http.get<any>(apiUrl).pipe(
      map((response) => response),
      catchError((err) =>
        throwError(() => new Error('Application not submitted. Please try again!'))
      )
    );
  }

  getRegisteredSocietyList(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetallSocietyforworkflow`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Registerd Society List retrieval failed.'));
      })
    );
  }
  getSocietySteps(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=SocietyStep&Id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Society steps retrieval failed.'));
      })
    );
  }
  getRoleList() {
    const apiUrl = `${this.configService.getApiUrl()}/Common/GetMasterData?Action=RoleMst`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Society steps retrieval failed.'));
      })
    );
  }
  saveComments(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/InsertComments`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Save Comment Request Not Submitted. Please try again!'));
      })
    );
  }
  deleteComments(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/DeleteComment?id=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Delete Comment Request Not Submitted. Please try again!'));
      })
    );
  }
  getCommentsList(id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetComments?iSocietyDetailsid=${id}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Comments List retrieval failed.. Please try again!'));
      })
    );
  }
  onChangeState(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/ChangeStateofSociety`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Change State Request Not Submitted. Please try again!'));
      })
    );
  }
  getCommentsByRoleId(roleId: any, id: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/BindCommentslist?roleid=${roleId}&societyDetailsid=${id}`;

    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Comments List retrieval failed.. Please try again!'));
      })
    );
  }
  getCheckListForPhysicalInspection(societyId: any) {

    const apiUrl = `${this.configService.getApiUrl()}/Society/PhysicalInspection?id=${societyId}`;

    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Check List retrieval failed.. Please try again!'));
      })
    );
  }
  savePhysicalInspection(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/SavePhysicalInspection`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Save Comment Request Not Submitted. Please try again!'));
      })
    );
  }
  getRemark(societyId: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/GetRemark?id=${societyId}`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Check List retrieval failed.. Please try again!'));
      })
    );
  }
  changeCheckListStatus(id: any, statusid: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/ChangePhysicalinspection?id=${id}&statusid=${statusid}`;

    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Check List status updation failed.. Please try again!'));
      })
    );
  }
  uploadCheckListImage(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/UploadFilePhysicalinspection`;

    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Check List image uploaded failed.. Please try again!'));
      })
    );
  }
  changeAct() {
    const apiUrl = `${this.configService.getApiUrl()}/Society/changeAct`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Change Act failed.. Please try again!'));
      })
    );
  }
  DeleteMember() {
    const apiUrl = `${this.configService.getApiUrl()}/Society/DeleteMember`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Change Act failed.. Please try again!'));
      })
    );
  }

  GetMemberCountCastWise(iSocietyDetailsId: any): Observable<any[]> {
    return this.http.get<any[]>(`${this.configService.getApiUrl()}/SocietyUserDashboard/GetDashboardData?iSocietyDetailsId=${iSocietyDetailsId}`);
  }

   getManuallyProcessedSociety(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/Society/ManuallyProcessedSociety`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Registerd Society List retrieval failed.'));
      })
    );
  }

 //#region AnnualDocumentUpload2006
  getDropDownDocTypes() {
  
    const apiUrl = `${this.configService.getApiUrl()}/AnnualDocumentUpload2006/GetDocTypes`;
    return this.http.get<any>(apiUrl).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Document types retrieval failed.'));
      })
    );
  }


   saveDocument(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/AnnualDocumentUpload2006/SaveDocument`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Document save failed.'));
      })
    );
  }

  /** Hits AnnualDocumentUpload2006/SubmitDocuments → SP ACTION SubmitDocuments */
  submitdocsdata(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/AnnualDocumentUpload2006/SubmitDocuments`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Documents submit failed.'));
      })
    );
  }

  getSocietyDocuments(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/AnnualDocumentUpload2006/GetSocietyDocuments`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Society documents retrieval failed.'));
      })
    );
  }

  /** Annual Document History grid — SP GetDealingHandList (society name from TSocietyDetails). */
  getDealingHandList(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/AnnualDocumentUpload2006/GetDealingHandList`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Annual document history retrieval failed.'));
      })
    );
  }

   deleteDocument(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/AnnualDocumentUpload2006/DeleteDocument`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => {
        return response;
      }),
      catchError((err) => {
        return throwError(() => new Error('Document delete failed.'));
      })
    );
  }

  getAnnualDocumentProgress(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/AnnualDocumentUpload2006/GetProgress`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => response),
      catchError(() => throwError(() => new Error('Progress retrieval failed.')))
    );
  }

  /** FY / calendar years for Annual Document History filter — GET GetYears */
  getAnnualDocumentYears(iSocietyDetailsID?: number) {
    let apiUrl = `${this.configService.getApiUrl()}/AnnualDocumentUpload2006/GetYears`;
    if (iSocietyDetailsID) {
      apiUrl += `?iSocietyDetailsID=${iSocietyDetailsID}`;
    }
    return this.http.get<any>(apiUrl).pipe(
      map((response) => response),
      catchError(() => throwError(() => new Error('Years retrieval failed.')))
    );
  }

  /** Header remarks (sDealingHeadRemark) — existing GetRemarkDoc2006; used as Progress Bar fallback. */
  getAnnualDocumentRemark(data: { iAnnualDocumentId: number }) {
    const apiUrl = `${this.configService.getApiUrl()}/AnnualDocumentUpload2006/GetRemarkDoc2006`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => response),
      catchError(() => throwError(() => new Error('Remark retrieval failed.')))
    );
  }

  approvedDocDH(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/AnnualDocumentUpload2006/ApprovedDocDH`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => response),
      catchError(() => throwError(() => new Error('Document accept failed.')))
    );
  }

  sendBackToSociety(data: any) {
    const apiUrl = `${this.configService.getApiUrl()}/AnnualDocumentUpload2006/SendBackToSociety`;
    return this.http.post<any>(apiUrl, data).pipe(
      map((response) => response),
      catchError(() => throwError(() => new Error('Document return failed.')))
    );
  }

  //#endregion
}
